// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"d993d003","377":"a9f0e5ce","666":"1572a9c3","787":"a3552447","924":"f5c776db"}[chunkId] + ".chunk.js";
};